import client from "./config";

//////////////// blogs ////////////////
const url = "blog_tags/";
export const getBlogTagsRequest = (value) => client.get(url, value);

export const addBlogTagRequest = (values) => client.post(url, values);
export const deleteBlogTagRequest = (values) => client.delete(`${url}${values}`);
